<sc-activate-account-error-container>
  El tiempo para activar la cuenta expiró, <a id="go-to-sign-up" [routerLink]="appRoutes.signUp">creá la cuenta nuevamente</a>
</sc-activate-account-error-container>